import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import logo from './logo.svg';

const Navbar = () => {
    return (
        <nav className="main-navbar" style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', left: '1.5rem', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
                <a
                    href="https://www.publicinterestnews.org.uk/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="PINF Home"
                    style={{ display: 'flex' }}
                >
                    <img src={logo} alt="PINF Logo" style={{ height: '40px' }} />
                </a>
                <Link to="/" style={{ textDecoration: 'none', color: 'white', fontFamily: 'fraktion-sans-regular', fontSize: '1rem', lineHeight: '1.2', borderLeft: '1px solid rgba(255,255,255,0.3)', paddingLeft: '0.8rem' }}>
                    Local<br />News Map
                </Link>
            </div>
            <div className="nav-links">
                <NavLink to="/" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    Map View
                </NavLink>
                <NavLink to="/dashboard" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    Dashboard
                </NavLink>
                <NavLink to="/methodology" className={({ isActive }) => isActive ? "nav-item active" : "nav-item"}>
                    Methodology
                </NavLink>
            </div>
        </nav>
    );
};

export default Navbar;
